import { types } from '../types/types';

export const websocket = (objWS: unknown) => ({
	type: types.websocket,
	payload: {
		objWS,
	},
});
